import { useEffect, useState } from 'react';

/**
 * False on the server and in the first render, true once the component is in the page. Buttons
 * stay disabled until then, so nothing is submitted before the browser can handle it, and pickers
 * render the server's markup first (no hydration mismatch).
 */
const useIsMounted = () => {
  const [isMounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);
  return isMounted;
};

export default useIsMounted;
